/*=========================================================================================
  File Name: moduletypologyActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	addTypology({commit}, typology) {
		return new Promise((resolve, reject) => {
			Api.post("/typology", typology)
				.then((response) => {
					commit("ADD_TIPOLOGY", Object.assign(typology, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// ACTIONS FOR RESORCES
	fetchTypology({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/typology")
				.then((res) => {
					commit("SET_TIPOLOGIES", res.data);
					resolve(res);
				})
				.catch((err) => {
					throw new Error(err);
				});
		});
	},
	fetchTipologyById({commit}, tipologyId) {
		return new Promise((resolve, reject) => {
			Api.get(`/tipology/${tipologyId}`)
				.then((res) => {
					//commit('GET_RESOURCE_BY_ID', res.data)
					resolve(res);
				})
				.catch((err) => {
					throw new Error(err);
				});
		});
	},
	updateTipology({commit}, tipology) {
		return new Promise((resolve, reject) => {
			Api.put(`/typology/${tipology.id}`, tipology)
				.then((response) => {
					commit("UPDATE_TIPOLOGY", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeTipology({commit}, tipologyId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/typology/${tipologyId}`)
				.then((response) => {
					commit("REMOVE_TIPOLOGY", tipologyId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	setDescription({commit}, data) {
		return new Promise((resolve, reject) => {
			commit("SET_DESCRIPTION", data);
			resolve(data);
		});
	},
	setName({commit}, index, name) {
		commit("SET_NAME", index, name);
	},
};
